<template>
  <div class="solutionsContainer">
    <div class="tinter"></div>
    <section class="solutionsPage">
      <div class="solutionsPageHeader">
        <h1>{{title}}</h1>
        <h2>{{subTitle}}</h2>
      </div>
      <div class="solutionsPageBody" v-for="(solution,index) in solutions" :key="index">
        <img :src="solution.icon" :alt="solution.title">
        <h1>{{solution.title}}</h1>
        <h2>{{solution.subTitle}}</h2>
      </div>
    </section>
  </div>
</template>

<script>
import MobileLogo from '@/assets/hgMain/mobile.svg';
import DashboardLogo from '@/assets/hgMain/dashboard.svg';
import SystemTechLogo from '@/assets/hgMain/systems.svg';

export default {
  name: 'SolutionsPage',
  data() {
    return {
      title: 'Innovative Solutions',
      subTitle: 'For a multitude of challenges',
      solutions: [
        {
          icon: MobileLogo,
          title: 'Mobile Applications',
          subTitle: 'Over the course of nearly a decade, the team at Highground Technologies has developed a diverse set of products  that include consumer oriented local search, sports news alerts and user generated video applications. Our technology team has delivered mobile projects across diverse platforms starting from SMS and Blackberry (#1 app on Blackberry), through to Windows Phone, Android and iOS. We have also helped some of the worlds most popular mobile applications with their own mobile development and use of machine learning to improve their retention and relevance. Having expertise in both mobile development and artificial intelligence, allows us to deliver AI infused mobile apps, that understand personalization, content creation and consumption.'
        },
        {
          icon: DashboardLogo,
          title: 'Dashboard Interfaces',
          subTitle: 'Mobile applications are often used by our users in the field, while the dashboard interfaces are the workhorse applications that are used by users at their desktops, day in and out, 24x7 to generate important insights for their organizations. The wealth of the signals that are generated by our AI technologies are visualized in easy to use dashboards that provide easy interpretation and decision making. The application of practical human-machine interface guidelines results in dashboards that are intuitive and actionable. '
        },
        {
          icon: SystemTechLogo,
          title: 'System and Technology',
          subTitle: 'Highground Techonologies team has been developing natural language, machine learning and artificial intelligence systems for over ten years. Our AI solutions have been used for anti money-laundering efforts by governments, for protection of the intellectual property rights, automated news detection, video classification and conversational chat bots. Our world class team implements the state of the art AI solutions in practical settings, enabling real-time decision making and analysis in various fields including security and news. '
        }
      ]
    }
  },
}
</script>

<style scoped>
@media (max-width: 900px) {
  .solutionsPage {
    position: relative;
    padding: 3rem 5rem;
    text-align: center;
    background: #1e1e1e;
    color: white;
    display: grid;
    grid-template-rows: 1fr 3fr 3fr 3fr;
    grid-gap: 1rem 10rem;
  }
  .solutionsPageHeader > h1 {
    font-size: 5vw;
    margin-bottom: 0;
  }
  .solutionsPageHeader > h2 {
    font-size: 2.5vw;
    margin-bottom: 0;
  }
  .solutionsPageBody > img {
    height: auto;
    width: 30%;
  }
  .solutionsPageBody > h1 {
    font-size: 3vw;
    margin-bottom: 0;
  }
  .solutionsPageBody > h2 {
    font-size: 2vw;
    margin-bottom: 0;
  }
}
@media (min-width: 900px) {
  .solutionsContainer {
    position: relative;
    background: url('../../assets/road.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;    
    -o-background-size: cover;      
    background-size: cover;
  }
  .tinter {
    background: #1e1e1e;
    position: absolute;
    opacity: 0.9;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .solutionsPage {
    position: relative;
    padding: 3rem 10rem;
    text-align: center;
    color: white;
    display: grid;
    grid-template-rows: 1fr 3fr 3fr 3fr;
    grid-gap: 2rem 10rem;
  }
  .solutionsPageHeader > h1 {
    font-size: 5vw;
    margin-bottom: 0;
  }
  .solutionsPageHeader > h2 {
    font-size: 2vw;
    margin-bottom: 0;
  }
  .solutionsPageBody > img {
    height: auto;
    width: 30%;
  }
  .solutionsPageBody > h1 {
    font-size: 3vw;
    margin-bottom: 0;
  }
  .solutionsPageBody > h2 {
    font-size: 1.5vw;
    padding: 0 5rem;
    margin-bottom: 0;
  }
}

</style>
